import { isAfter, startOfDay } from 'date-fns';
export const generateTimeSlots = currentDate => {
  const slots = [];
  const baseDate = new Date(currentDate);
  baseDate.setHours(0, 0, 0, 0);
  const hours = Array.from({
    length: 24
  }, (_, i) => i);
  const minutes = ['00', '30'];
  hours.forEach(hour => {
    minutes.forEach(minute => {
      const date = new Date(baseDate);
      date.setHours(hour, parseInt(minute), 0, 0);
      const formattedHour = hour % 12 || 12;
      const amPm = hour < 12 ? 'AM' : 'PM';
      const label = "".concat(formattedHour, ":").concat(minute, " ").concat(amPm);
      const value = date.toISOString();
      const testPrefix = label.replace(/\s+/g, '').toLowerCase();
      slots.push({
        dateTimeValue: value,
        timeLabel: label,
        slotTestId: testPrefix
      });
    });
  });
  return slots;
};
export const getCurrentTimeSlot = (currentDate, now) => {
  const slots = generateTimeSlots(currentDate);
  const currentTime = new Date(currentDate);

  // If selected date is in the future (not today), return first slot (12:00 AM)
  const selectedDate = startOfDay(currentDate);
  const today = startOfDay(now);
  if (isAfter(selectedDate, today)) {
    return slots[0];
  }

  // For today, find the next slot that is at least 15 minutes ahead
  const minimumTime = new Date(currentTime.getTime() + 15 * 60 * 1000);
  const nextSlot = slots.find(slot => new Date(slot.dateTimeValue) >= minimumTime);
  return nextSlot || slots[0];
};
export const getAvailableTimeSlots = (currentDate, now) => {
  const slots = generateTimeSlots(currentDate);
  const currentSlot = getCurrentTimeSlot(currentDate, now);
  return slots.filter(slot => new Date(slot.dateTimeValue) >= new Date(currentSlot.dateTimeValue));
};